import { buildOp, type Op, type OpBody, type OpKind } from "./op.js";
import type { Identity } from "./crypto.js";
import type { OpStore } from "./store.js";
import { validateAndAdd, type ValidationResult } from "./validate.js";

// The one way to author an op on a store: pick a valid (capped) parent set,
// advance the lamport clock past every parent, build, validate, add. Callers
// supply ts so replicas and tests stay deterministic.
export function appendOp(
  store: OpStore,
  identity: Identity,
  kind: OpKind,
  body: OpBody,
  ts: number,
): { op: Op; result: ValidationResult } {
  const parents = store.headsForNewOp();
  const lamport =
    parents.length === 0
      ? 0
      : Math.max(...parents.map((h) => (store.get(h) as Op).lamport)) + 1;
  const op = buildOp(identity, { group: store.groupId, parents, lamport, ts, kind, body });
  return { op, result: validateAndAdd(store, op) };
}
